/**
 * Who may see a form in the Client Portal and the Messenger. The same rule lives, unchanged, in
 * client_portal/Gorelo_CX_Web/src/form/form-visibility.ts: they are separate packages, so keep the
 * two files identical.
 *
 *  1. "Allow In Portal" must be on.
 *  2. Client: no client restriction, or the contact's client is listed.
 *  3. Contact tags: no tag restriction, or the contact has AT LEAST ONE of the listed tags (OR).
 *
 * An empty or missing list means "no restriction", so forms saved before contact tags existed are
 * unaffected.
 */
export interface FormVisibilityFields {
  allowInPortal?: boolean | null;
  clientIds?: Array<number | string> | null;
  contactTagIds?: Array<number | string> | null;
}

export interface FormViewer {
  /** The contact's client; 0 or null when not resolved yet. */
  clientId: number | null | undefined;
  /** The contact's tag ids. */
  tagIds: Array<number | string> | null | undefined;
}

export function isFormVisibleToContact(form: FormVisibilityFields, viewer: FormViewer): boolean {
  if (form.allowInPortal !== true) return false;

  const clients = form.clientIds ?? [];
  if (clients.length > 0) {
    const clientId = viewer.clientId;
    if (!clientId || !clients.some((id) => Number(id) === Number(clientId))) return false;
  }

  const required = form.contactTagIds ?? [];
  if (required.length > 0) {
    const mine = viewer.tagIds ?? [];
    if (!required.some((tag) => mine.some((own) => Number(own) === Number(tag)))) return false;
  }

  return true;
}
